import React, { useEffect, useState } from "react";
import * as bootstrap from "bootstrap";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import OverviewTab from "./alltabs/OverviewTab";
import ParkSharedSafaries from "./safaris/ParkSharedSafaries";
import ParkReview from "./review/ParkReview";
import { useParksViewContext } from "provider/ParkViewProvider";
import ParkMainOverView from "./ParkMainOverView";
import ParkMainOverViewSkeleton from "components/common/Skeleton/park/ParkMainOverViewSkeleton";
import ParkPackages from "./packages/ParkPackages";

const SafariParkViewDetails = () => {
  const { parkViewLoading } = useParksViewContext();
  const [key, setKey] = useState("operators");


  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);


  return (
    <>
      <section className="articals_wrapper" style={{ background: "#fff" }}>
        <Container fluid>
          {parkViewLoading
            ? <ParkMainOverViewSkeleton />
            : <ParkMainOverView />
          }
          <Row
            className="pt-2 itenary_tabs  position-relative justify-content-center"
            id="safari_tour_operator_container"
          >
            <Col xl={10}>
              <Row>
                <Col
                  lg={8}
                  xl={9}
                  xxl={10}
                  className=" mt-2 position-relative safartabs"
                >
                  <div className="overflow-auto w-100 hide-scrollbar">
                    <Tabs
                      id="myTab"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="slider_addmobile3 owl-theme d-flex gap-2 flex-nowrap"
                    >
                      <Tab
                        eventKey="operators"
                        title="Overview"
                        className="nav-item"
                      ></Tab>
                      <Tab
                        eventKey="packages"
                        title="Packages"
                        className="nav-item"
                      ></Tab>
                      <Tab
                        eventKey="shared-safari"
                        title="Shared Safaris"
                        className="nav-item"
                      ></Tab>
                      {/* <Tab
                      eventKey="park-reviews"
                      title="Reviews"
                      className="nav-item"
                    ></Tab> */}
                    </Tabs>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="">
        <Container fluid>
          <Row className="my-lg-4 my-2 pt-3 justify-content-center margin_bottomfooter mb-5">

            <Col xxl={10} xl={12} lg={12}>
              <Row>
                {key === "operators" && (
                  <Col>
                    <OverviewTab />
                  </Col>
                )}
                {key === "packages" && (
                  <Col lg={12}>
                    <ParkPackages />
                  </Col>
                )}
                {key === "shared-safari" && (
                  <Col lg={12}>
                    <ParkSharedSafaries />
                  </Col>
                )}

                {key === "park-reviews" && (
                  <Col lg={12}>
                    <ParkReview />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default SafariParkViewDetails;